import config from '../config.json'

export const env = process.env.NODE_ENV || 'development'
export const stage = config.instance.stage // eslint-disable-line prefer-destructuring
export const profile = config.instance.awsAccount
